module.exports = __webpack_public_path__ + "static/img/pic-index-banner.2fca317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/pic-index-banner.png
// module id = 1639
// module chunks = 0